import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { X } from 'lucide-react';

const CarrierPeopleSection = () => {
  const { watch, setValue } = useFormContext();
  const formCarrierPeople = watch('carrier.people') || [];

  // Temporary form state for adding new person
  const [tempPerson, setTempPerson] = useState({
    type: 'driver',
    fullName: '',
    email: '',
    phoneNumber: ''
  });

  // Handle input changes
  const handleInputChange = (field, value) => {
    setTempPerson(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle adding a new person
  const handleAddPerson = () => {
    const fullName = tempPerson.fullName.trim();
    
    if (fullName) {
      const newPerson = {
        type: tempPerson.type || 'driver',
        fullName: fullName,
        email: tempPerson.email.trim() || '',
        phoneNumber: tempPerson.phoneNumber.trim() || ''
      };
      const currentPeople = formCarrierPeople || [];
      const newPeople = [...currentPeople, newPerson];
      setValue('carrier.people', newPeople, { shouldDirty: true });
      
      // Reset temp form
      setTempPerson({
        type: 'driver',
        fullName: '',
        email: '',
        phoneNumber: ''
      });
    }
  };

  const handleRemovePerson = (index) => {
    const currentPeople = formCarrierPeople || [];
    const newPeople = currentPeople.filter((_, i) => i !== index);
    setValue('carrier.people', newPeople, { shouldDirty: true });
  };

  return (
    <div className="customer-representative-peoples-section">
      <h3 className="section-title">People</h3>
      <label className="form-label">
        Add people (drivers/dispatchers) for this carrier (optional)
      </label>
      
      {formCarrierPeople.length > 0 && (
        <div className="selected-items-list">
          {formCarrierPeople.map((person, index) => {
            const fullName = person.fullName || '';
            const type = person.type || 'driver';
            const email = person.email || '';
            const phoneNumber = person.phoneNumber || '';
            
            return (
              <div 
                key={`person-${index}-${fullName}`} 
                className="selected-item-tag"
              >
                <span>
                  <strong>{type === 'driver' ? 'Driver' : 'Dispatcher'}:</strong> {fullName}
                  {email && ` - ${email}`}
                  {phoneNumber && ` - ${phoneNumber}`}
                </span>
                <button
                  type="button"
                  className="remove-tag-button"
                  onClick={() => handleRemovePerson(index)}
                >
                  <X size={14} />
                </button>
              </div>
            );
          })}
        </div>
      )}

      <div className="add-person-form">
        <h4>Add New Person</h4>
        <div>
          <div className="form-group">
            <label htmlFor="carrierPersonType" className="form-label">Type *</label>
            <select
              id="carrierPersonType"
              className="form-select"
              value={tempPerson.type}
              onChange={(e) => handleInputChange('type', e.target.value)}
            >
              <option value="driver">Driver</option>
              <option value="dispatcher">Dispatcher</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="carrierPersonFullName" className="form-label">Full Name *</label>
            <input
              id="carrierPersonFullName"
              type="text"
              className="form-input"
              placeholder="Full Name"
              value={tempPerson.fullName}
              onChange={(e) => handleInputChange('fullName', e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAddPerson();
                }
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="carrierPersonEmail" className="form-label">Email</label>
            <input
              id="carrierPersonEmail"
              type="email"
              className="form-input"
              placeholder="email@example.com"
              value={tempPerson.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="carrierPersonPhone" className="form-label">Phone Number</label>
            <input
              id="carrierPersonPhone"
              type="tel"
              className="form-input"
              placeholder="Phone Number"
              value={tempPerson.phoneNumber}
              onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
            />
          </div>

          <button
            type="button"
            onClick={handleAddPerson}
            className="add-person-form__button"
          >
            Add Person
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarrierPeopleSection;

